import { ReactNode } from "react";
import { BannerWrapper } from "../BannerWrapper";
import { UpgradeButton } from "../UpgradeButton";

type BannerLocation = "AI banner" | "Template banner";

type Props = {
  title: string;
  description: string;
  location: BannerLocation;
  children?: ReactNode;
};

/** IMPORTANT! This banner is s being used in the following locations:
 *  - AI Copilot
 *  - template widget
 *  - template page (ex: app/canvas/template/lead-capture)
 *
 *  Be conscientious that changes made here will affect all three.
 *
 *  If you want this banner to show up locally, return an object in upgradeBannerPropsAtom_SUSPENDS
 * */
export function UpgradeBanner({ title, description, children }: Props) {
  /* AI Copilot: all 3 buttons are rendered (start over, modify prompt, upgrade)
   * Template widget: 2 buttons are rendered (start blank and upgrade)
   * Template page: only upgrade button is rendered
   * */
  return (
    <BannerWrapper title={title} description={description}>
      {children}
      <UpgradeButton />
    </BannerWrapper>
  );
}
